<div class="container">
  <div
    class="d-flex justify-content-center align-items-center flex-column gap-2"
  >
    <h1 class="text-2xl fw-600 mb-2">
      <span class="text-black">Verify your email</span>
    </h1>
    <div class="text-sm text__gray text-center">
      An OTP has been sent to {{ email }}.
    </div>
    @if (email) {
      <div
        class="text-sm text-primary fw-500 mb-3 cursor-pointer"
        (click)="editEmail()"
      >
        (Edit)
      </div>
    }
  </div>

  <ngx-otp-input
    [options]="otpInputConfig"
    (otpComplete)="handleFillEvent($event)"
    (otpChange)="handleOtpChange($event)"
  >
  </ngx-otp-input>

  <button
    class="btn w-100 mt-3"
    [ngClass]="otpValue.length === otpLength ? 'btn-secondary' : 'btn-disabled'"
    type="button"
    (click)="onVerifyOTP()"
    [disabled]="!isOtpFilled"
  >
    Verify OTP
  </button>

  <div class="otp-text text-sm mt-3 row">
    <div class="col-md-12 otp-alerts mt10 pt-10" id="resend">
      @if (!isTimerOn && !resendEnabled) {
        <p class="pointer active-text label-form">
          Didn’t get a code? Resend OTP in
          <span id="timeLeft"></span>
        </p>
      }
      @if (!isTimerOn && resendEnabled) {
        <span
          class="active-text label-form resend-label"
          (click)="onResendOTP($event)"
          >Didn’t get a code?
          <span class="text-decoration-underline cursor-pointer"
            >Click to resend.</span
          >
        </span>
      }
    </div>
  </div>
</div>
